import axios from '@/libs/api.request'
// 获取评论的list
export const getCustomerQuestionPage = data => {
  return axios.request({
    url: '/customer/question/page',
    data,
    method: 'POST'
  })
}
// 保存评论
export const saveCustomerQuestion = data => {
  return axios.request({
    url: '/customer/question/save',
    data,
    method: 'POST'
  })
}
// 评论是否有帮助
export const subCustomerQuestionEval = data => {
  return axios.request({
    url: '/customer/question/evaluation',
    data,
    method: 'POST'
  })
}
